import { Version } from '@helpers/version/version';

export const SERVICEMESH_VERSION = new Version('18.0.0').full;
